import { STHead } from "@/components";
import { STHome } from "@/components/STHome";
import Head from "next/head";

export default function Home() {
  return (
    <>
      <STHead
        title="Inventors of advanced biomaterials"
        description="Inventors of advanced biomaterials to replace fossil-based materials as a drop-in technology without any green premium or capital overheads."
        keywords="Biomaterials, Advanced biomaterials, barrier coatings, PPWR-compliant barrier coatings, Recyclable packaging, CEPI-Part 1 compliant packaging, Rotogravure coatings, solid-state coatings, coatings for flexible packaging, circular paper packaging, biomass to biocoatings, EPR ready packaging, PPWR regulated packaging"
        canonicalUrl="https://sustanix.com"
        url="https://sustanix.com"
        ogTitle="Inventors of advanced biomaterials"
        ogDescription="Sustanix develops novel biomolecules for advanced biomaterials, takes it from lab to industrial scale"
        ogKeywords="Biomaterials, Advanced biomaterials, barrier coatings, PPWR-compliant barrier coatings, Recyclable packaging, CEPI-Part 1 compliant packaging, Rotogravure coatings, solid-state coatings, coatings for flexible packaging, circular paper packaging, biomass to biocoatings, EPR ready packaging, PPWR regulated packaging"
        ogUrl="https://sustanix.com"
        ogImage="https://sustanix.com/opengraph-image.webp"
        ogType="website"
      />
      <STHome />
    </>
  );
}
